import { Outlet, Link, useLocation } from 'react-router-dom';
import { BarChart3, UploadCloud, Database, FileText, Calculator, Home } from 'lucide-react';

export default function Layout() {
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') return true;
    return path !== '/' && location.pathname.startsWith(path);
  };

  return (
    <div className="flex h-screen bg-[#09090b]">
      <aside className="w-64 border-r border-white/10 bg-[#18181b] flex flex-col">
        <div className="p-6 border-b border-white/10">
          <h1 className="text-2xl font-bold text-white" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Reports App
          </h1>
          <p className="text-sm text-gray-400 mt-1">Data Analytics Platform</p>
        </div>
        <nav className="flex-1 p-4 sidebar-nav">
          <Link
            to="/"
            className={`flex items-center gap-3 px-4 py-3 rounded-md mb-2 ${isActive('/') ? 'active' : 'text-gray-300 hover:text-cyan-400'
              }`}
            data-testid="nav-dashboard"
          >
            <Home size={20} />
            <span>Dashboard</span>
          </Link>
          <Link
            to="/upload"
            className={`flex items-center gap-3 px-4 py-3 rounded-md mb-2 ${isActive('/upload') ? 'active' : 'text-gray-300 hover:text-cyan-400'
              }`}
            data-testid="nav-upload"
          >
            <UploadCloud size={20} />
            <span>1. Incarcare Fisiere</span>
          </Link>
          <Link
            to="/data"
            className={`flex items-center gap-3 px-4 py-3 rounded-md mb-2 ${isActive('/data') ? 'active' : 'text-gray-300 hover:text-cyan-400'
              }`}
            data-testid="nav-data"
          >
            <Database size={20} />
            <span>2. Baza de Date</span>
          </Link>
          <Link
            to="/selection"
            className={`flex items-center gap-3 px-4 py-3 rounded-md mb-2 ${isActive('/selection') ? 'active' : 'text-gray-300 hover:text-cyan-400'
              }`}
            data-testid="nav-selection"
          >
            <FileText size={20} />
            <span>3. Selectie Rapoarte</span>
          </Link>
          <Link
            to="/reports"
            className={`flex items-center gap-3 px-4 py-3 rounded-md mb-2 ${isActive('/reports') ? 'active' : 'text-gray-300 hover:text-cyan-400'
              }`}
            data-testid="nav-reports"
          >
            <FileText size={20} />
            <span>4. Rapoarte</span>
          </Link>
          <Link
            to="/custom-reports"
            className={`flex items-center gap-3 px-4 py-3 rounded-md mb-2 ${isActive('/custom-reports') ? 'active' : 'text-gray-300 hover:text-cyan-400'
              }`}
            data-testid="nav-custom-reports"
          >
            <Calculator size={20} />
            <span>5. Rapoarte Customizabile</span>
          </Link>
        </nav>
        <div className="p-4 border-t border-white/10">
          <div className="flex items-center gap-2 text-sm text-gray-400">
            <BarChart3 size={16} className="text-cyan-400" />
            <span>Powered by Analytics</span>
          </div>
        </div>
      </aside>
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}

export const MetricCard = ({ title, value, icon: Icon, color = 'cyan' }) => {
  const colorClasses = {
    cyan: 'text-cyan-400 border-cyan-500/50',
    purple: 'text-purple-400 border-purple-500/50',
    pink: 'text-pink-400 border-pink-500/50',
    green: 'text-green-400 border-green-500/50',
    orange: 'text-orange-400 border-orange-500/50'
  };

  return (
    <div className={`metric-card bg-[#18181b] rounded-xl border border-white/10 p-6 hover:border-${color}-500/50`}>
      <div className="flex items-center justify-between mb-2">
        <p className="text-sm text-gray-400">{title}</p>
        <Icon size={20} className={colorClasses[color].split(' ')[0]} />
      </div>
      <p className="text-3xl font-bold text-white" style={{ fontFamily: 'Manrope, sans-serif' }}>
        {value}
      </p>
    </div>
  );
};